import { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { getClientDomain } from "./useFetchUnits";
import { useAnnouncements } from "./useFetchAnnouncements";
import { useDotButton } from "../components/templates/design1/components/SimilarProperties";
import { logEnvironment } from "@components/lib/utils";

export const useCarouselAnnouncements = () => {
  // 1. Carousel setup
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: "auto",
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    // Run once immediately when emblaApi is ready
    onSelect();

    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi, onSelect]);
  // 2. Fetch announcements
  const page = 1;
  const location = getClientDomain("carousel announceent");
  logEnvironment("this the carousel announcement componennt");

  const { data, isLoading, isError } = useAnnouncements(location, page);

  // Early returns
  const isDataReady = !!data && !isLoading && !isError;
  const rawResponse = isDataReady ? data[0] : null;
  const announcements = isDataReady ? data[1] : [];

  return {
    emblaRef,
    emblaApi,
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
    canScrollPrev,
    canScrollNext,
    isLoading,
    isError,
    rawResponse,
    announcements,
    isDataReady,
  };
};
